import { post, get, put } from '@api/request';

export async function fetchMassLinkSaletoDeeds(
  { appraisalService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appraisalService}/appraisal/masslinksaletodeeds?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createMassLinkSaletoDeeds(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/masslinksaletodeeds`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function matchMassLinkSaletoDeeds(
  { appraisalService },
  authenticationToken,
  { payload, runID },
) {
  const url = `${appraisalService}/appraisal/masslinksaletodeed/${runID}/match`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function finalizeMassLinkSaletoDeeds(
  { appraisalService },
  authenticationToken,
  { runID },
) {
  const url = `${appraisalService}/appraisal/masslinksaletodeed/${runID}/finalize`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchMassLinkSaletoDeedDetails(
  { appraisalService },
  authenticationToken,
  { runID, page, pageSize, filter },
) {
  const url = `${appraisalService}/appraisal/masslinksaletodeed/${runID}/details?page=${page}&pageSize=${pageSize}&filter=${filter}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
